export default function(country) {
    const stringsToRemove = ["(*)", ", not elsewhere specified", ", The"];

    stringsToRemove.forEach(string => {
        country = country.replace(string, "");
    });

    return country;
}



// WEBPACK FOOTER //
// ./src/js/utilities/sanitize-country-name.js